export default "__VITE_ASSET__$oUiuAXR7gZMKRQU56HW2w__$_?as=run__"